import apiDtMood from './dtMoodApiHandler'
import { getDtMoodSession } from './dtmood-session.service'

const phrase = '¡Motívate y logra tus objetivos!'

const getPhraseDay = () => {
  const dtMoodSession = getDtMoodSession()
  const clientId = dtMoodSession ? dtMoodSession.clientId : ''
  const groupId = dtMoodSession ? dtMoodSession.groupId : ''

  return new Promise((resolve, reject) => {
    apiDtMood
      .get(`/phrases/today?clientId=${clientId}&groupId=${groupId}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export { phrase, getPhraseDay }
